import { useEffect, useState } from "react";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { IManualConfigDTO } from "../../Interfaces/deltaHedgeMarketmaking";
import {
  getManualConfig,
  setServerManualConfig,
} from "../../Requests/deltaHedgeMarketmaking";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { getCalls, getPuts } from "../../Requests/deltaHedgeAdjustment";
import { getGroups } from "../../Requests/optionDomain";
import Button from "../../Components/Button";
import ToggleSwitch from "../../Components/ToggleSwitch";

interface IProps {
  onClose: () => void;
}

const ManualConfig = ({ onClose }: IProps) => {
  const [formValues, setFormValues] = useState({} as IManualConfigDTO);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!formValues.groupId) return;
    setLoading(true);
    getManualConfig(formValues.groupId)
      .then((resp) => {
        setFormValues({ ...resp, groupId: formValues.groupId });
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, [formValues.groupId]);

  const submitHandler = () => {
    setLoading(true);
    setServerManualConfig(formValues)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const commonChangeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const psChangeHandler = (name: string, value: any) => {
    setFormValues({
      ...formValues,
      ps: {
        ...formValues.ps,
        [name]: value,
      },
    });
  };
  const csChangeHandler = (name: string, value: any) => {
    setFormValues({
      ...formValues,
      cs: {
        ...formValues.cs,
        [name]: value,
      },
    });
  };

  return (
    <div className="flex flex-col justify-start items-start gap-2 w-full">
      <div className="font-bold">انتخاب دستی</div>
      <div className="w-[300px]">
        <DynamicDropdown
          dropdown={{
            name: "groupId",
            placeholder: "گروه",
            extraLabel: true,
          }}
          getData={getGroups}
          onChange={commonChangeHandler}
          value={formValues.groupId}
        />
      </div>
      <div className="flex flex-row justify-start items-center gap-2 w-full">
        <div>CS</div>
        <div className="w-64">
          <DynamicDropdown
            dropdown={{
              name: "ins1",
              placeholder: "کال فروش",
              extraLabel: true,
              disabled: !formValues.groupId || formValues?.cs?.auto,
            }}
            getData={getCalls}
            onChange={csChangeHandler}
            value={formValues?.cs?.ins1?.toString()}
            inputId={formValues.groupId}
          />
        </div>
        <div className="w-64">
          <DynamicDropdown
            dropdown={{
              name: "ins2",
              placeholder: "کال خرید",
              extraLabel: true,
              disabled: !formValues.groupId || formValues?.cs?.auto,
            }}
            getData={getCalls}
            onChange={csChangeHandler}
            value={formValues?.cs?.ins2?.toString()}
            inputId={formValues.groupId}
          />
        </div>
        <ToggleSwitch
          checked={formValues?.cs?.auto}
          label="اتوماتیک"
          name="auto"
          onChange={csChangeHandler}
        />
      </div>
      <div className="flex flex-row justify-start items-center gap-2 w-full">
        <div>PS</div>
        <div className="w-64">
          <DynamicDropdown
            dropdown={{
              name: "ins1",
              placeholder: "پوت فروش",
              extraLabel: true,
              disabled: !formValues.groupId || formValues?.ps?.auto,
            }}
            getData={getPuts}
            onChange={psChangeHandler}
            value={formValues?.ps?.ins1?.toString()}
            inputId={formValues.groupId}
          />
        </div>
        <div className="w-64">
          <DynamicDropdown
            dropdown={{
              name: "ins2",
              placeholder: "پوت خرید",
              extraLabel: true,
              disabled: !formValues.groupId || formValues?.ps?.auto,
            }}
            getData={getPuts}
            onChange={psChangeHandler}
            value={formValues?.ps?.ins2?.toString()}
            inputId={formValues.groupId}
          />
        </div>
        <ToggleSwitch
          checked={formValues?.ps?.auto}
          label="اتوماتیک"
          name="auto"
          onChange={psChangeHandler}
        />
      </div>
      <div className="w-min mr-auto">
        <Button text="ثبت" variant="contained" onClick={submitHandler} />
      </div>
    </div>
  );
};

export default ManualConfig;
